import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { UserDto, UserRole } from '@fleet-beat/core';
import { AuthService } from '@fleet-beat/shared';

@Injectable()
export class DisallowAdminGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): boolean {
    const user: UserDto = this.authService.authUser;
    if (user.role == UserRole.Admin) {
      this.router.navigate(['/admin/companies']);
      return false;
    }
    return true;
  }
}
